import { render, staticRenderFns } from "./AddElement.vue?vue&type=template&id=179a9860&"
import script from "./AddElement.vue?vue&type=script&lang=js&"
export * from "./AddElement.vue?vue&type=script&lang=js&"
import style0 from "./AddElement.vue?vue&type=style&index=0&id=179a9860&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports